import {
    Component,
    inject,
    signal,
    viewChild,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { UserService, User } from 'src/app/services/userService';
import { NavItem, navItems } from './navigation';
import {
    BreakpointService,
    ScreenSize,
} from 'src/app/services/breakpoint.service';
import { ToolbarComponent } from '../toolbar/toolbar.component';
import { MatNavList } from '@angular/material/list';
import { MenuListItemComponent } from './menu-list-item/menu-list-item.component';
import { RouterOutlet } from '@angular/router';

import { MatIconModule } from '@angular/material/icon';
import { LoginService } from 'src/app/services/utility/login.service';

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatSidenavModule,
        ToolbarComponent,
        MatNavList,
        MenuListItemComponent,
        RouterOutlet,
        MatIconModule,
    ],
})
export class SidenavComponent {
    readonly sidenav = viewChild.required<MatSidenav>('sidenav');
    navItems = navItems;
    login = inject(LoginService);

    sidenavState = signal<boolean>(true);

    public user;
    hydraEnv = '';
    mode: any = 'side';
    screenSize = ScreenSize.XLarge;

    constructor(
        private userService: UserService,
        breakpoint: BreakpointService,
    ) {
        this.user = this.userService.user;
        const url = window.location.href;
        this.hydraEnv = url.split('://')[1].split('-')[0];
        breakpoint.screenSize.subscribe((s) => {
            this.mode = s >= ScreenSize.Large ? 'side' : 'over';
            this.sidenavState.set(s >= ScreenSize.Large);
            this.screenSize = s;
        });
    }

    navigateToHydra(env: string) {
        window.location.href = env;
    }

    ngAfterViewInit(): void {
        if (!this.user()) this.login.openLoginPopUp();
    }

    menu = (user: User): NavItem[] => {
        if (!user) return [];
        const items = navItems
            .filter(
                (x) =>
                    !x.access ||
                    this.userService.hasAccess(x.access.id, x.access.action),
            )
            .flatMap((x) => {
                x.children = x.children?.filter(
                    (y) =>
                        !y.access ||
                        this.userService.hasAccess(
                            y.access.id,
                            y.access.action,
                        ),
                );
                if (!x.children?.length) return [];
                return x;
            });
        return items;
    };
}
